import './Mapa.css'

import { Button, Col, Container, Row, Table } from 'react-bootstrap'
import 'leaflet/dist/leaflet.css'
import { Bar, Chart, Line } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import { forwardRef, useEffect,  useImperativeHandle,  useRef, useState } from 'react'
import Moment from 'react-moment'
import L from 'leaflet';
import 'react-data-grid/lib/styles.css';
import { redirect, useNavigate } from 'react-router-dom'
import PopupGrafico from '../PopupGrafico';
import Translator from '../I18n/Translator';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer';

const position =  [-13.442152, -42.311251];//[-13.357907, -42.305862];// [-12.32362979101804, -42.28573502390884];

const defaultZoom = 6.25;
const zoomSnap_ = 0.25;
const wheelPxPerZoomLevel_ = 120;

var data_local = null;

var legenda = [];
var legenda2 = [];
var dados_municipios = require('./BA/dados.json');

var geojsonFeature = require('./BA/BA_Municipios_2021.json');

var dados_municipios_sesab = require('./BA/dados_sesab.json');


var semanas_epidemiologicas = null;
var dados_municipios_por_data = null;
var dados_municipios_por_data_sesab = null;
var dados = [];
var dados2 = [];
var dados3 = [];
var dados4 = [];

var dados_media_movel = [];
var dados_variacao_media_movel = [];

var dados_totais = [];
var dados_totais_sesab = [];

var dados_o_num = [];
var dados_e_thr = [];
var dados_u_b_thr = []; 
var dados_e_h_estimate = [];
var dados_p_e_h_estimate = [];

var teste_data = "";
var shapeFileMapaMediaMovel = null;
var shapeFileMapaTaxaAtendimento = null;
var shapeFileMapaExcesso = null;

var max_data = null;
var max_data2 = null;
var max_dados3 = null;
var max_mm = null;
var max_vmm = null;
var max_p_e_h_estimate = null;
var max_e_h_estimate = null;
var max_u_b_thr = null;
var max_e_thr = null;
var max_o_num = null;
var max_data_excess_thr = null;
var max_data_media_movel = null;

var textoLegenda = "";
var layerAtiva = "mm";

var corSelecao = 'white';

function checkDado(dado){
  return dado['date'] === teste_data;
}

var datas = [];

var alterandoData = false;
var filtrandoMunicipio = false;

var fontGrafico = 10;

function trataNaNeNull(dado){
  return dado == null || dado == "" || dado == "NaN" ? "nil" : dado
}

function fixaCasasDecimais(valor, casasDecimais){
  if(valor === "nil") 
    return "nil";
  return parseFloat(valor).toFixed(casasDecimais).replace('.', ',');
}

function preparaInt(valor){
  /*var valor_temp = valor + "";
  valor_temp.replace(".", "");*/
  return valor;
}

var layerControl = null;

dados_municipios["atendimentos"].forEach(function(atendimento) {
    var obj = {
      "date" : atendimento["data"],
      "total_geral" : atendimento["total_geral"],
      "total_gripal" : atendimento["total_gripal"],
      "media_movel" : atendimento["media_movel"],
      "variacao_media_movel" : atendimento["variacao_media_movel"],
    };
    
    /*obj[date] = municipio["atendimento"]["data"];
    obj['total_geral'] = municipio["atendimento"]["total_geral"];
    obj['total_gripal'] = municipio["atendimento"]["total_gripal"];*/

    datas.push(obj["date"]);
  
    var busca = dados_totais.find(dt => dt["date"] === obj["date"]);
  
    if(busca != null){
      teste_data = obj["date"];
      obj["total_geral"] = obj["total_geral"] + busca["total_geral"];
      obj["total_gripal"] = obj["total_gripal"] + busca["total_gripal"];
      obj["media_movel"] = obj["media_movel"] + busca["media_movel"];
      obj["variacao_media_movel"] = obj["variacao_media_movel"] + busca["variacao_media_movel"];
      var idx = dados_totais.findIndex(checkDado);
      dados_totais[idx] = obj;
    } else {
      dados_totais.push(obj);
    }
});

dados_municipios_sesab["amostras"].forEach(function(atendimento) {
  var obj = {
    "date" : atendimento["data"],
    "observed_number" : atendimento["observed_number"],
    "exceeds_threshold" : atendimento["exceeds_threshold"],
    "upper_bound_threshold" : atendimento["upper_bound_threshold"],
    "excess_higher_estimate" : atendimento["excess_higher_estimate"],
    "percent_excess_higher_estimate" : atendimento["percent_excess_higher_estimate"],
  };
  
  /*obj[date] = municipio["atendimento"]["data"];
  obj['total_geral'] = municipio["atendimento"]["total_geral"];
  obj['total_gripal'] = municipio["atendimento"]["total_gripal"];*/

  //datas.push(obj["date"]);

  var busca = dados_totais_sesab.find(dt => dt["date"] === obj["date"]);

  if(busca != null){
    teste_data = obj["date"];
    obj["observed_number"] = obj["observed_number"] + busca["observed_number"];
    obj["exceeds_threshold"] = obj["exceeds_threshold"] + busca["exceeds_threshold"];
    obj["upper_bound_threshold"] = obj["upper_bound_threshold"] + busca["upper_bound_threshold"];
    obj["excess_higher_estimate"] = obj["excess_higher_estimate"] + busca["excess_higher_estimate"];
    obj["percent_excess_higher_estimate"] = obj["percent_excess_higher_estimate"] + busca["percent_excess_higher_estimate"];
    var idx = dados_totais_sesab.findIndex(checkDado);
    dados_totais_sesab[idx] = obj;
  } else {
    dados_totais_sesab.push(obj);
  }
});

/*dados_totais = Object.fromEntries(
  dados_totais.map(({data, total}) => [data, total])
);*/
var acumulado_gripal = 0;
dados_totais.forEach(function (dado){
  var obj = {};
  obj['data'] = dado["date"];
  obj['total'] = dado["total_geral"];
  dados.push(obj);

  var obj2 = {};
  obj2['data'] = dado["date"];
  obj2['total'] = dado["total_gripal"];
  dados2.push(obj2);

  var obj3 = {};
  obj3['data'] = dado["date"];
  obj3['total'] = ((dado["total_gripal"] / dado["total_geral"]) * 100);
  dados3.push(obj3);

  acumulado_gripal += dado["total_gripal"];
  var obj4 = {};
  obj4['data'] = dado["date"];
  obj4['total'] = acumulado_gripal;
  dados4.push(obj4);

  var obj5 = {};
  obj5['data'] = dado["date"];
  obj5['total'] = dado["media_movel"];
  dados_media_movel.push(obj5);

  var obj6 = {};
  obj6['data'] = dado["date"];
  obj6['total'] = dado["variacao_media_movel"];
  dados_variacao_media_movel.push(obj6);

});

/*dados_municipios[0]["atendimentos"].forEach(function (atendimento) {
  var obj = {};
  obj['data'] = atendimento["data"];
  obj['total'] = atendimento["total_geral"];
  dados.push(obj);
  //legenda.push(atendimento["data"]);
});*/

dados = Object.fromEntries(
  dados.map(({data, total}) => [data, total])
);

/*dados_municipios[0]["atendimentos"].forEach(function (atendimento) {
  var obj = {};
  obj['data'] = atendimento["data"];
  obj['total'] = atendimento["total_gripal"];
  dados2.push(obj);
  //legenda2.push(new Date(atendimento["data"]));
});*/

dados2 = Object.fromEntries(
  dados2.map(({data, total}) => [data, total])
);


dados3 = Object.fromEntries(
  dados3.map(({data, total}) => [data, total])
);

dados4 = Object.fromEntries(
  dados4.map(({data, total}) => [data, total])
);

dados_media_movel = Object.fromEntries(
  dados_media_movel.map(({data, total}) => [data, total])
);

dados_variacao_media_movel = Object.fromEntries(
  dados_variacao_media_movel.map(({data, total}) => [data, total])
);

dados_totais_sesab.forEach(function (dado){
  var obj = {};
  obj['data'] = dado["date"];
  obj['total'] = dado["observed_number"];
  dados_o_num.push(obj);

  var obj2 = {};
  obj2['data'] = dado["date"];
  obj2['total'] = dado["exceeds_threshold"];
  dados_e_thr.push(obj2);

  /*var obj3 = {};
  obj3['data'] = dado["date"];
  obj3['total'] = (dado["total_gripal"] / dado["total_geral"]) * 100;
  dados3.push(obj3);

  acumulado_gripal += dado["total_gripal"];
  var obj4 = {};
  obj4['data'] = dado["date"];
  obj4['total'] = acumulado_gripal;
  dados4.push(obj4);*/

  var obj5 = {};
  obj5['data'] = dado["date"];
  obj5['total'] = dado["upper_bound_threshold"];
  dados_u_b_thr.push(obj5);

  var obj6 = {};
  obj6['data'] = dado["date"];
  obj6['total'] = dado["excess_higher_estimate"] > 0 ? dado["excess_higher_estimate"] : 0;
  dados_e_h_estimate.push(obj6);

  var obj7 = {};
  obj7['data'] = dado["date"];
  obj7['total'] = dado["percent_excess_higher_estimate"];
  dados_p_e_h_estimate.push(obj7);

});


dados_o_num = Object.fromEntries(
  dados_o_num.map(({data, total}) => [data, total])
);

dados_e_thr = Object.fromEntries(
  dados_e_thr.map(({data, total}) => [data, total])
);

dados_u_b_thr = Object.fromEntries(
  dados_u_b_thr.map(({data, total}) => [data, total])
);

dados_e_h_estimate = Object.fromEntries(
  dados_e_h_estimate.map(({data, total}) => [data, total])
);

dados_p_e_h_estimate = Object.fromEntries(
  dados_p_e_h_estimate.map(({data, total}) => [data, total])
); 

var layerTile = null;
var layerGroup = null;
var posicao = localStorage.getItem('posicaoScroll');

var legend = null;

var layerOld = null;

var texto_grafico_dark = "#fff";
var texto_grafico_light = "#000";

function getIdxCidade(lista, municipio){
  for (let i = 0; i < lista.length; i++){
    if(lista[i]["municipio"] == municipio)
    {
      return i;
    }
  }
  return -1;
}

function getIdxCidadeWhereCodIbge(lista, municipio){
  for (let i = 0; i < lista.length; i++){
    if(lista[i]["cod_ibge"] == municipio)
    {
      return i;
    }
  }
  return -1;
}


const Mapa = forwardRef((props, ref) => { 
  const { t } = useTranslation();

  var txtTotalAtendimentos = t("dashboard.graficos.titulo_atendimento_totais");
  var txtTotalGripal = t("dashboard.graficos.titulo_atendimento_gripais");
  var txtTaxaAtendimentos = t("dashboard.graficos.legenda_mm.2");
  var txtNomeMunicipio = t("dashboard.cidade");
  var txtSemanaEpdemiologica = props.data === 'pt' ? "Semana Epidemiológica" : "Epidemiological Week";

  var nomes_municipios = [{
    "cod_ibge":0,
    "municipio": t("dashboard.todos")
  }]
  
  /*
  dados_municipios["municipios"].forEach(function(municipio) {
    nomes_municipios.push({
      "cod_ibge" : municipio["cod_ibge"],
      "municipio":municipio["municipio"]
    });
  }); */

  function getSemanaEpidemiologica(data){
    var semana_ep = 0;
    for(let idx_data = 0; idx_data < semanas_epidemiologicas.length; idx_data++){
      if(semanas_epidemiologicas[idx_data]["data"] === data){
        semana_ep = semanas_epidemiologicas[idx_data]["semana"];
        break;
      }
    }
    return semana_ep;
  }

  function getDataLabelGrafico(context){
    const datasetIndex = context.datasetIndex;
    const dataPoint = context.dataIndex;

    var retorno = [];
    if(context["dataset"]["label"] === t("dashboard.graficos.legenda_mm.2")){
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.legenda_mm.2") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
      } else {
        var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade]["populacao"]);
        retorno.push(t("dashboard.graficos.legenda_mm.2") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
      }
    } else if(context["dataset"]["label"] === t("dashboard.graficos.legenda_mm.1")) {
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.legenda_mm.1") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
      } else {
        var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade]["populacao"]);
        retorno.push(t("dashboard.graficos.legenda_mm.1") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
      }
    } if(context["dataset"]["label"] === t("dashboard.graficos.titulo_variacao_mm")){
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.titulo_variacao_mm") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
      } else {
        var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade]["populacao"]);             
        retorno.push(t("dashboard.graficos.titulo_variacao_mm") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
      }
    } else if(context["dataset"]["label"] === t("dashboard.graficos.titulo_atendimento_gripais")) {
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.titulo_atendimento_gripais") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["amostras"][dataPoint]["data"]));
      } else {
        var idxCidade2 = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        var idxCidade = getIdxCidadeWhereCodIbge(dados_municipios_sesab["municipios"], dados_municipios["municipios"][idxCidade2]["cod_ibge"]);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade2]["populacao"]);    
        retorno.push(t("dashboard.graficos.titulo_atendimento_gripais") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
      }
    } else if(context["dataset"]["label"] === t("dashboard.graficos.titulo_limite")) {
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.titulo_limite") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["amostras"][dataPoint]["data"]));
      } else {
        var idxCidade2 = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        var idxCidade = getIdxCidadeWhereCodIbge(dados_municipios_sesab["municipios"], dados_municipios["municipios"][idxCidade2]["cod_ibge"]);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade2]["populacao"]);
        retorno.push(t("dashboard.graficos.titulo_limite") + ": " + context["formattedValue"]);    
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
      }
    } else if(context["dataset"]["label"] === t("dashboard.graficos.titulo_excesso")) {
      if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.graficos.titulo_excesso") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["amostras"][dataPoint]["data"]));
      } else {
        var idxCidade2 = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
        var idxCidade = getIdxCidadeWhereCodIbge(dados_municipios_sesab["municipios"], dados_municipios["municipios"][idxCidade2]["cod_ibge"]);
        if(idxCidade == -1)
          return "";
        retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
        retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade2]["populacao"]);    
        retorno.push(t("dashboard.graficos.titulo_excesso") + ": " + context["formattedValue"]);
        retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
        retorno.push(preparaMesAno(dados_municipios_sesab["municipios"][idxCidade]["amostras"][dataPoint]["data"]));
      }
    } 
    return retorno;
  }

  function getOptions(max, theme, titulo){
    var passo = 5;
    if(max % 2 == 0) {
      passo = 6;
    }
    passo = max / passo;
    passo = Math.round(passo);
    return {
      responsive: true,
      maintainAspectRatio: true,
      layout:{
        padding: {
          left: 5,
          right: 0,
          top: -10,
          bottom: 5
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: context => {
              if(context["element"]["options"]["backgroundColor"] == "rgba(255, 255, 255, 1)")
                return "";
  
              const datasetIndex = context.datasetIndex;
              const dataPoint = context.dataIndex;

              if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
                var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
                retorno.push(txtTotalAtendimentos + ": " + 
                  preparaInt(dados_municipios["atendimentos"][dataPoint]["total_geral"]));
                retorno.push(txtTotalGripal + ": " + 
                  preparaInt(dados_municipios["atendimentos"][dataPoint]["total_gripal"]));            
                retorno.push(txtTaxaAtendimentos + ": " + 
                parseFloat(dados_municipios["atendimentos"][dataPoint]["taxa"]).toFixed(2) + "%");
                retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["atendimentos"][dataPoint]["data"]));
                retorno.push(preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
              } else {
                var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
                if(idxCidade == -1)
                  return "";
                var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
                retorno.push(t("dashboard.table.col2") + ": " + dados_municipios["municipios"][idxCidade]["populacao"]);
                retorno.push(txtTotalAtendimentos + ": " + 
                  preparaInt(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_geral"]));
                retorno.push(txtTotalGripal + ": " + 
                  preparaInt(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_gripal"]));
                retorno.push(txtTaxaAtendimentos + ": " + 
                  fixaCasasDecimais(dados_municipios["atendimentos"][dataPoint]["taxa"], 2)+ "%") ;
                retorno.push(txtSemanaEpdemiologica + ": " + getSemanaEpidemiologica(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));
                retorno.push(preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));   
              }
              return retorno;
              /*["municipios"][""]["municipio"];
              ["municipios"][""][data_atendimento]["total_gripal"];
              ["municipios"][""][data_atendimento]["total_geral"];
              ["municipios"][""][data_atendimento]["taxagripais_atendtotais"];*/
              //return 'Hello';
            }
          }
        },
        legend: {
          onClick: null,
          position: 'bottom',
          align: 'start',
          labels: {
            boxWidth: 15,
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
            font: { 
              size: 10
            }
          }
        },
        title: {
          display: true,
          text: titulo,
          color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          position: 'top',
        },
      },
      scales: {
        y: {  // not 'yAxes: [{' anymore (not an array anymore)
          ticks: {
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
            // fontSize: 18,
            font: {
              size: fontGrafico, // 'size' now within object 'font {}'
            },
            //stepSize: passo,
            beginAtZero: true
          },
          beginAtZero: true,
          callback: function(value, index, ticks) {
            return preparaInt(value);
          }
        },
        x: {  // not 'xAxes: [{' anymore (not an array anymore)
          /*ticks: {
            color: "#fff",  // not 'fontColor:' anymore
            //fontSize: 14,
            font: {
              size: 14 // 'size' now within object 'font {}'
            },
            stepSize: 1,
            beginAtZero: true
          }*/
          ticks:{
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
            font: {
              size: fontGrafico, // 'size' now within object 'font {}'
            },
          },
          type: 'time',
          time: {
            parser: 'YYYY/MM/DD',
            unit: 'day',
            unitStepSize: 7,
            displayFormats: {
              'day': 'DD/MM/YYYY'
            }
          }
        }
      }
    }
  }

  function getOptions_Line(max, theme, perc, titulo){
      var max_local = Math.ceil(max);
      var passo = 5;
      if(max_local % 2 == 0) {
        passo = 6;
      }
      if(passo < max_local)
        passo = max_local / passo;
      passo = passo.toFixed(2);

      if(max_local == 0)
        passo = 10;

      return {
        responsive: true,
        maintainAspectRatio: true,
        layout:{
          padding: {
            left: 5,
            right: 0,
            top: -10,
            bottom: 5
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: context => {
                context["formattedValue"] = perc ? fixaCasasDecimais(context["formattedValue"],2) + "%" : context["formattedValue"];
                if(context["element"]["options"]["backgroundColor"] == "rgba(255, 255, 255, 1)")
                  return "";

                return getDataLabelGrafico(context);
              }
            }
          },
          legend: {
            display: true,
            onClick: null,
            position: 'bottom',
            align: 'start',
            labels: {
              boxWidth: 15,
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              font: { 
                size: 10
              }
            }
          },
          title: {
            display: true,
            text: titulo,
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
            position: 'top',
          },
        },
        scales: {
          y: {  // not 'yAxes: [{' anymore (not an array anymore)  
            ticks: {
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
              // fontSize: 18,
              font: {
                size: fontGrafico, // 'size' now within object 'font {}'
              },
              //stepSize: passo,
              beginAtZero: true,
              callback: function(value, index, ticks) {
                return value + (perc == true ? '%' : '');
              }
            },
            beginAtZero: true,
          },
          x: {  // not 'xAxes: [{' anymore (not an array anymore)
            ticks:{
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              font: {
                size: fontGrafico, // 'size' now within object 'font {}'
              },
            },
            type: 'time',
            time: {
              parser: 'YYYY/MM/DD',
              unit: 'day',
              unitStepSize: 7,
              displayFormats: {
                'day': 'DD/MM/YYYY'
              }
            }
          }
        }
        
      }
  }

  function getOptions_Line_Double(max, theme, perc, titulo){
    var passo = 5;
      if(max % 2 == 0) {
        passo = 6;
      }
      if(passo < max)
        passo = max / passo;
      passo = passo.toFixed(2);
      return {
        responsive: true,
        maintainAspectRatio: true,
        layout:{
          padding: {
            left: 5,
            right: 0,
            top: -10,
            bottom: 5
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: context => {
                context["formattedValue"] = perc ? fixaCasasDecimais(context["formattedValue"],2) + "%" : context["formattedValue"];
                return getDataLabelGrafico(context);
                
                /*if(context["element"]["options"]["backgroundColor"] == "rgba(255, 255, 255, 1)")
                  return "";*/
              }
            }
          },
          legend: {
            display: true,
            onClick: null,
            position: 'bottom',
            align: 'start',
            labels: {
              boxWidth: 15,
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              font: { 
                size: 10
              }
            }
          },
          title: {
            display: true,
            text: titulo,
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
            position: 'top',
          },
        },
        scales: {
          y: {  // not 'yAxes: [{' anymore (not an array anymore)
            ticks: {
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
              // fontSize: 18,
              font: {
                size: fontGrafico, // 'size' now within object 'font {}'
              },
              //stepSize: passo,
              callback: function(value, index, ticks) {
                return value + (perc ? '%' : '');
              }
            },
            beginAtZero: true
          },
          x: {  // not 'xAxes: [{' anymore (not an array anymore)
            ticks:{
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              font: {
                size: fontGrafico, // 'size' now within object 'font {}'
              },
            },
            type: 'time',
            time: {
              parser: 'YYYY/MM/DD',
              unit: 'day',
              unitStepSize: 7,
              displayFormats: {
                'day': 'DD/MM/YYYY'
              }
            }
          }
        }
        
      }
  }
  

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout:{
      padding: {
        left: 5,
        right: 0,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: context => {
            if(context["element"]["options"]["backgroundColor"] == "rgba(255, 255, 255, 1)")
              return "";

            const datasetIndex = context.datasetIndex;
            const dataPoint = context.dataIndex;
            
            if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
              var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
              retorno.push(txtTotalAtendimentos + ": " + 
                dados_municipios["atendimentos"][dataPoint]["total_geral"]);
              retorno.push(txtTotalGripal + ": " + 
                dados_municipios["atendimentos"][dataPoint]["total_gripal"]);            
              retorno.push(txtTaxaAtendimentos + ": " + 
                (((dados_municipios["atendimentos"][dataPoint]["total_gripal"] / dados_municipios["atendimentos"][dataPoint]["total_geral"]) * 100)).toFixed(2));
              retorno.push(txtSemanaEpdemiologica + ": " + preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
            } else {
              var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
              if(idxCidade == -1)
                return "";
              var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
              retorno.push(txtTotalAtendimentos + ": " + 
              dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_geral"]);
              retorno.push(txtTotalGripal + ": " + 
              dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_gripal"] );
              retorno.push(txtTaxaAtendimentos + ": " + 
              (((dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_gripal"] / dados_municipios["atendimentos"][dataPoint]["total_geral"]) * 100)).toFixed(2));
              retorno.push(txtSemanaEpdemiologica + ": " +preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));   
            }
            return retorno;
            /*["municipios"][""]["municipio"];
            ["municipios"][""][data_atendimento]["total_gripal"];
            ["municipios"][""][data_atendimento]["total_geral"];
            ["municipios"][""][data_atendimento]["taxagripais_atendtotais"];*/
            //return 'Hello';
          }
        }
      },
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          boxWidth: 0,
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 12
          }
        }
      },
      title: {
        fullSize: true,
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          // fontSize: 18,
          font: {
            size: fontGrafico, // 'size' now within object 'font {}'
          },
          //stepSize: 1000,
          beginAtZero: true
        },
        beginAtZero: true
      },
      x: {  // not 'xAxes: [{' anymore (not an array anymore)
        /*ticks: {
          color: "#fff",  // not 'fontColor:' anymore
          //fontSize: 14,
          font: {
            size: 14 // 'size' now within object 'font {}'
          },
          stepSize: 1,
          beginAtZero: true
        }*/
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: {
            size: fontGrafico, // 'size' now within object 'font {}'
          },
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };

  const options_double = {
    responsive: true,
    maintainAspectRatio: true,
    layout:{
      padding: {
        left: 5,
        right: 0,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      tooltip: {
        /*callbacks: {
          label: context => {
            if(context["element"]["options"]["backgroundColor"] == "rgba(255, 255, 255, 1)")
              return "";

            const datasetIndex = context.datasetIndex;
            const dataPoint = context.dataIndex;
            
            if(municipioSelecionado == "All" || municipioSelecionado == "Todos"){
              var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
              retorno.push(txtTotalAtendimentos + ": " + 
                dados_municipios["atendimentos"][dataPoint]["total_geral"]);
              retorno.push(txtTotalGripal + ": " + 
                dados_municipios["atendimentos"][dataPoint]["total_gripal"]);            
              retorno.push(txtTaxaAtendimentos + ": " + 
                (((dados_municipios["atendimentos"][dataPoint]["total_gripal"] / dados_municipios["atendimentos"][dataPoint]["total_geral"]) * 100)).toFixed(2));
              retorno.push(txtSemanaEpdemiologica + ": " + preparaMesAno(dados_municipios["atendimentos"][dataPoint]["data"]));
            } else {
              var idxCidade = getIdxCidade(dados_municipios["municipios"], municipioSelecionado);
              if(idxCidade == -1)
                return "";
              var retorno = [txtNomeMunicipio + ": " + municipioSelecionado];
              retorno.push(txtTotalAtendimentos + ": " + 
              dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_geral"]);
              retorno.push(txtTotalGripal + ": " + 
              dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_gripal"] );
              retorno.push(txtTaxaAtendimentos + ": " + 
              (((dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["total_gripal"] / dados_municipios["atendimentos"][dataPoint]["total_geral"]) * 100)).toFixed(2));
              retorno.push(txtSemanaEpdemiologica + ": " +preparaMesAno(dados_municipios["municipios"][idxCidade]["atendimentos"][dataPoint]["data"]));   
            }
            return retorno;
          }
        }*/
      },
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          boxWidth: 15,
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 12
          }
        }
      },
      title: {
        fullSize: true,
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          // fontSize: 18,
          font: {
            size: fontGrafico, // 'size' now within object 'font {}'
          },
          //stepSize: 5,
          
        },
        beginAtZero: true
      },
      x: {  // not 'xAxes: [{' anymore (not an array anymore)
        /*ticks: {
          color: "#fff",  // not 'fontColor:' anymore
          //fontSize: 14,
          font: {
            size: 14 // 'size' now within object 'font {}'
          },
          stepSize: 1,
          beginAtZero: true
        }*/
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: {
            size: fontGrafico, // 'size' now within object 'font {}'
          },
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };
  
  const options2 = {
    responsive: true,
    layout:{
      padding: {
        left: 5,
        right: 10,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 13
          }
        }
      },
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        
        /*max: 21600,
        min: 0,*/
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          // fontSize: 18,
          font: {
            size: fontGrafico, // 'size' now within object 'font {}'
          },
          //stepSize: 1000,
          beginAtZero: true
        }
      },
      /*x: {  // not 'xAxes: [{' anymore (not an array anymore)
        ticks: {
          color: "#fff",  // not 'fontColor:' anymore
          //fontSize: 14,
          font: {
            size: 14 // 'size' now within object 'font {}'
          },
          stepSize: 1,
          beginAtZero: true
        }
      }*/
      x: {
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          tooltipFormat: 'll HH:mm',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };

  const navigate = useNavigate();

  function getLinguagem(){
    var ling = "en";
    const elemento = document.getElementsByClassName("selected-lang");
          elemento[0].classList.forEach((item) => {
            if(item === "pt")
              ling = "pt";
          });
    return ling;
  }

  window.addEventListener('beforeprint', () => {
    for (let id in Chart.instances) {
      Chart.instances[id].resize();
    }
  });
  window.addEventListener('afterprint', () => {
    for (let id in Chart.instances) {
      Chart.instances[id].resize();
    }
  });

  window.onscroll = function (e) {
    posicao = window.scrollY;
    localStorage.setItem('posicaoScroll', JSON.stringify(posicao));
  }

  function logout(){
    props.loginToParent(false, "");
  }

  function getCidades(){
    nomes_municipios = []

    if(shapeFileMapaMediaMovel != null){
      Object.keys(shapeFileMapaMediaMovel["_layers"]).forEach((shape) => {
        nomes_municipios.push({
          "cod_ibge" : shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"],
          "municipio": shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["NM_MUN"]
        });
      });

      nomes_municipios.sort((a,b) => a["municipio"].localeCompare(b["municipio"]));
    }

    nomes_municipios.unshift({
      "cod_ibge":0,
      "municipio": t("dashboard.todos")
    })

    return nomes_municipios;
  }

  function tabelaOrdenada() {
    var tMakers = [...markers];

    /**if(campoOrdem === "taxagripais_atendtotais" ){
      if(decrescente) {
        tMakers.sort((a,b) => (parseFloat(a[campoOrdem]) > parseFloat(b[campoOrdem])) ? -1 : 1);
      } else {
        tMakers.sort((a,b) => (parseFloat(a[campoOrdem]) < parseFloat(b[campoOrdem])) ? -1 : 1);
      }
    } 
    else*/
    if(campoOrdem === "taxagripais_atendtotais" || campoOrdem === "variacao_media_movel" || campoOrdem === "limite_superior" || campoOrdem === "excesso"){
      if(decrescente) {
        tMakers.sort(function(a, b){return b[campoOrdem]-a[campoOrdem];});
      } else {
        tMakers.sort(function(a, b){return a[campoOrdem]-b[campoOrdem];});
      }
    }
    else
    if(campoOrdem === "municipio"){
      if(decrescente) {
        tMakers.sort((a,b) => b[campoOrdem].localeCompare(a[campoOrdem]));
      } else {
        tMakers.sort((a,b) => a[campoOrdem].localeCompare(b[campoOrdem]));
      }
    } else {
      if(decrescente) {
        tMakers.sort((a,b) => (a[campoOrdem] > b[campoOrdem]) ? -1 : 1);
      } else {
        tMakers.sort((a,b) => (a[campoOrdem] > b[campoOrdem]) ? 1 : -1);
      }
    }

    if(posicao) {
        setTimeout(function() {
            window.scrollTo(0, posicao);
        }, 1);
    }

    return tMakers;
  }

  let map = useRef(null);

  function criarLegenda(min, max, variavel, linguagem) {
    if(legend != null){
      map.current.removeControl(legend);
      legend = null;
    }
    legend = L.control({ position: "bottomleft" });

    if(variavel == "mm"){
      legend.onAdd = function(map) {
        if(linguagem === "pt")
          var div = L.DomUtil.create("div", "legend2");
        else 
          var div = L.DomUtil.create("div", "legend3");
        div.innerHTML += '<div class="lgd">';
        div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">'+t("dashboard.queda")+'</td><td style="text-align:center">'+t("dashboard.estavel")+'</td><td style="text-align:right">'+t("dashboard.alta")+'</td></tr>';
        div.innerHTML += '</table>';
        div.innerHTML += '</div>';
        return div;
      };
      /*
      if(linguagem === "pt"){
        legend.onAdd = function(map) {
          var div = L.DomUtil.create("div", "legend2");
          div.innerHTML += '<div class="lgd">';
          div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">Queda</td><td style="text-align:center">Estável</td><td style="text-align:right">&nbsp;&nbsp;Alta&nbsp;&nbsp;</td></tr>';
          div.innerHTML += '</table>';
          div.innerHTML += '</div>';
          return div;
        };
      } else {
        legend.onAdd = function(map) {
          var div = L.DomUtil.create("div", "legend2");
          div.innerHTML += '<div class="lgd">';
          div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">Falling</td><td style="text-align:center">Stable</td><td style="text-align:right">Rising</td></tr>';
          div.innerHTML += '</table>';
          div.innerHTML += '</div>';
          return div;
        };
      }*/

      /*legend.onAdd = function(map) {
        var div = L.DomUtil.create("div", "legend2");
        div.innerHTML += '<div class="lgd">';
        div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp</th><th  bgcolor="#FAFF00">&nbsp</th><th bgcolor="#FF1200">&nbsp</th></tr><tr><td style="text-align:left">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<0%&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</td><td style="text-align:center">>= 0% & <= 15%</td><td style="text-align:right">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp>15%&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</td></tr>';
        div.innerHTML += '</table>';
        div.innerHTML += '</div>';
        return div;
      };*/
    } else if(variavel != "ex"){
      legend.onAdd = function(map) {
        if(linguagem === "pt")
          var div = L.DomUtil.create("div", "legend2");
        else 
          var div = L.DomUtil.create("div", "legend3");
        div.innerHTML += '<div class="lgd">';
        div.innerHTML += textoLegenda;
        div.innerHTML += '</table>';
        div.innerHTML += '</div>';
        return div;
      };
    } else {
      legend.onAdd = function(map) {
        if(linguagem === "pt")
          var div = L.DomUtil.create("div", "legend2");
        else 
          var div = L.DomUtil.create("div", "legend");
        div.innerHTML += '<div class="lgd">';
        div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">'+t("dashboard.estavel")+'</td><td style="text-align:center">'+t("dashboard.atencao")+'</td><td style="text-align:right">'+t("dashboard.aviso")+'</td></tr>';
        div.innerHTML += '</table>';
        div.innerHTML += '</div>';
        return div;
      };
       /* 
      if(linguagem === "pt"){
        legend.onAdd = function(map) {
          var div = L.DomUtil.create("div", "legend2");
          div.innerHTML += '<div class="lgd">';
          div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">Estável</td><td style="text-align:center">Atenção</td><td style="text-align:right">Aviso</td></tr>';
          div.innerHTML += '</table>';
          div.innerHTML += '</div>';
          return div;
        };
      } else {
        legend.onAdd = function(map) {
          var div = L.DomUtil.create("div", "legend2");
          div.innerHTML += '<div class="lgd">';
          div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp&nbsp&nbsp</th><th  bgcolor="#FAFF00">&nbsp&nbsp&nbsp</th><th bgcolor="#FF1200">&nbsp&nbsp&nbsp</th></tr><tr><td style="text-align:left">Stable</td><td style="text-align:center">Attention</td><td style="text-align:right">Warning</td></tr>';
          div.innerHTML += '</table>';
          div.innerHTML += '</div>';
          return div;
        };
      }*/
    }
    
    legend.addTo(map.current);
  }

  var listBindPopup = [];
  var listBindPopup2 = [];

  function onEachFeature2(feature, layer) {
    layer.on({
        click: () => {
          var encontrou = false;
          for(let i = 0; i < dados_municipios_por_data_sesab["municipios"].length; i ++){
            if(dados_municipios_por_data_sesab["municipios"][i]["cod_ibge"] === parseInt(layer["feature"]["properties"]["CD_MUN"])){
              if(dados_municipios_por_data_sesab["municipios"][i]["observed_number"])
                encontrou = true;
            }     
          }

          if(layerOld != null){
            /*
            var cor = "#545453";
            for(let i = 0; i < dados_municipios_por_data['municipios'].length; i++){
              if(layerOld.hasOwnProperty("_map")){
                if(layerOld._map._popup._content.includes(dados_municipios_por_data['municipios'][i]['municipio'])){
                  cor = layerOld["fillColor"];
                  break;
                }
                console.log(layerOld._map._popup._content);
              }
              else
              {
                console.log(layerOld);
              }
            }*/
            layerOld.setStyle({weight: 0.5, color:layerOld["fillColor"]});
            layerOld = null;   
          } 

          layer.setStyle({weight: 3.5, color: corSelecao}); 
          layerOld = layer; 

          if(!encontrou){
            for(let i = 0; i < dados_municipios_por_data["municipios"].length; i ++){
              if(dados_municipios_por_data["municipios"][i]["cod_ibge"] === parseInt(layer["feature"]["properties"]["CD_MUN"])){
                encontrou = true;
              }     
            }
          }

          if(!encontrou)
            return;

          var ling = 'en';
                            
          ling = getLinguagem();

          filtrarMunicipio(parseInt(layer["feature"]["properties"]["CD_MUN"]), false, ling);
        },
    });
  }

  function onEachFeature(feature, layer) {
    layer.on({
        click: () => {
          var encontrou = false;
          for(let i = 0; i < dados_municipios_por_data["municipios"].length; i ++){
            if(dados_municipios_por_data["municipios"][i]["cod_ibge"] === parseInt(layer["feature"]["properties"]["CD_MUN"])){
              encontrou = true;
            }     
          }

          //console.log("onEach" + encontrou);

          if(!encontrou)
            return;

          if(layerOld != null){
            /*
            var cor = "#545453";
            for(let i = 0; i < dados_municipios_por_data['municipios'].length; i++){
              if(layerOld.hasOwnProperty("_map")){
                if(layerOld._map._popup._content.includes(dados_municipios_por_data['municipios'][i]['municipio'])){
                  cor = layerOld["fillColor"];
                  break;
                }
                console.log(layerOld._map._popup._content);
              }
              else
              {
                console.log(layerOld);
              }
            }*/
            layerOld.setStyle({weight: 0.5, color:layerOld["fillColor"]});
            layerOld = null;   
          } 

          layer.setStyle({weight: 3.5, color: corSelecao}); 
          layerOld = layer; 

          var ling = 'en';
                            
          ling = getLinguagem();

          filtrarMunicipio(parseInt(layer["feature"]["properties"]["CD_MUN"]), false, ling);
        },
    });
  }

  function removeWithTimeout(layer) {
    setTimeout(function() {
      map.current.removeLayer(layer);
    }, 10);
  }

  useEffect(() => {
    if(!props.login){
      navigate("/login");
      return;
    }
    
    //let url = ;
    if(layerTile != null && map.current != null){
      map.current.removeLayer(layerTile);
    }

    var url = props.theme === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
    
    layerTile = L.tileLayer(url, {
      zoomControl: true,
      zoomSnap: zoomSnap_,
      zoomDelta: zoomSnap_,
      wheelPxPerZoomLevel: wheelPxPerZoomLevel_,
      defaultZoom: defaultZoom,
      maxZoom: 18,
      id: 'mapbox.streets'
    });

    getSemana();
    
    getData (dataSelecionada, props.data, true);
    getData2(dataSelecionada, props.data, true);
    
    if(shapeFileMapaMediaMovel == null){
      shapeFileMapaMediaMovel = L.geoJSON(geojsonFeature, {
          style: function(feature) {         
              return {color: "#545453", stroke:true, weight:0.5};
          },
          onEachFeature: onEachFeature,
      }); 
    }

    /* Removendo Taxa de Atendimento das Camadas do Mapa
    if(shapeFileMapaTaxaAtendimento== null){
      shapeFileMapaTaxaAtendimento = L.geoJSON(geojsonFeature, {
          style: function(feature) {         
              return {color: "#545453", stroke:true, weight:0.5};
          },
          onEachFeature: onEachFeature,
      }); 
    } */

    if(shapeFileMapaExcesso == null) {
      shapeFileMapaExcesso = L.geoJSON(geojsonFeature, {
          style: function(feature) {         
              return {color: "#545453", stroke:true, weight:0.5};
          },
          onEachFeature: onEachFeature2,
      });
    }

    if(map.current == null){
      map.current = L.map("map", {
        layers: [layerTile, shapeFileMapaMediaMovel]
      });
    } else {
      map.current.invalidateSize();
    }

    const defaultCenter = position;

    /*var tileLayer = L.tileLayer(url, {
      zoomControl: true,
      zoomSnap: zoomSnap_,
      zoomDelta: zoomSnap_,
      wheelPxPerZoomLevel: wheelPxPerZoomLevel_,
      defaultZoom: defaultZoom,
      maxZoom: 18,
    });*/

 

    map.current.setView(defaultCenter, defaultZoom);
    //layerTile.addTo(map.current);

    map.current.on('overlayadd', function(event)
    {
      if(layerOld != null){
        var cor = layerOld["fillColor"];
        layerOld.setStyle({weight: 0.5, color:cor});
        layerOld = null;   
      } 

      /*if ( event.name === "Taxa de Atendimentos Gripais" || event.name === "Flu Rate Encounters") {
        if(map.current.hasLayer(shapeFileMapaMediaMovel))
        {
          removeWithTimeout(shapeFileMapaMediaMovel);
        }
        if(map.current.hasLayer(shapeFileMapaExcesso)){
          removeWithTimeout(shapeFileMapaExcesso);
        }
        criarLegenda(menorTaxa, maiorTaxa, "", props.data);   
        layerAtiva = "";     
      }*/
      if ( event.name === t("dashboard.titulo_mapa_taxa_crescimento")) {
        if(map.current.hasLayer(shapeFileMapaExcesso))
          removeWithTimeout(shapeFileMapaExcesso);
        /*if(map.current.hasLayer(shapeFileMapaTaxaAtendimento))
          removeWithTimeout(shapeFileMapaTaxaAtendimento);*/
        criarLegenda(0, 0, "mm", props.data);
        layerAtiva = "mm";
        setDataSelecionada(datas[4]);
        setIdxDataSelecionada(4);
        //filtrarMunicipio(municipioSelecionado, true, props.data);
        getData (datas[4], props.data, true);
        getData2(datas[4], props.data, true);
      }
      if ( event.name ===  t("dashboard.titulo_mapa_atendimentos_excedentes")) {
        if(map.current.hasLayer(shapeFileMapaMediaMovel))
          removeWithTimeout(shapeFileMapaMediaMovel);
        /*if(map.current.hasLayer(shapeFileMapaTaxaAtendimento))
          removeWithTimeout(shapeFileMapaTaxaAtendimento);*/
        criarLegenda(0, 0, "ex", props.data);
        layerAtiva = "ex";
        setDataSelecionada(datas[160]);
        setIdxDataSelecionada(160);
        //filtrarMunicipio(municipioSelecionado, true, props.data);
        getData (datas[160], props.data, true);
        getData2(datas[160], props.data, true);
      }
    });

    const baseLayers = {
      'Mapa': layerTile
    }
    
    var ling = 'en';
                            
    ling = getLinguagem();

    if(layerControl != null && map.current.hasLayer(layerControl)){
      map.current.removeLayer(layerControl);
    }


    var overlays = {};

    //overlays[props.data === "pt" ? 'Taxa de Atendimentos Gripais' :  'Flu Rate Encounters'] = shapeFileMapaTaxaAtendimento;
    overlays[t("dashboard.titulo_mapa_taxa_crescimento")] = shapeFileMapaMediaMovel;
    overlays[t("dashboard.titulo_mapa_atendimentos_excedentes")] = shapeFileMapaExcesso;

    layerControl = L.control.layers(null, overlays, {collapsed:false}).addTo(map.current);

    //shapeFileMapa.addTo(map.current);

    //myLayerControl.addOverlay(shapeFileMapa, 'Raw Materials');
    //console.log("useEffect");
    
    setTimeout(function(){
      map.current.setZoom(defaultZoom);
    }, 1000);

    //myLayer.addData(geojsonFeature);
/*
    shapeFileMapa = L.geoJSON(geojsonFeature, {
      style: function(feature) {
          
          return {color: "#545453", stroke:true, weight:0.5};
      },
      onEachFeature: onEachFeature,
  }).addTo(map.current); */

    
    /*const geo = L.geoJson(geojsonSHP,
      {
        onEachFeature: function popUp(f, l) {
          var out = [];
          if (f.properties) {
            for (var key in f.properties) {
              out.push(key + ": " + f.properties[key]);
            }
            l.bindPopup(out.join("<br />"));
          }
        }
      }
    ).addTo(map.current);*/
    
  }, [map])

  //var borderColor = "rgb(247, 152, 28)";
  //var backgroundColor = "rgba(247, 152, 28, 0.5)";

  var borderColor = "rgb(11, 186, 217)";
  var backgroundColor = "rgba(11, 186, 217, 0.5)";

  var borderColor2 = "rgb(245 , 75 , 9)"; 
  var backgroundColor2 = "rgba(245 , 75 , 9, 0.5)";

  //11, 186, 217

  var borderColor3 = "rgb(36, 245,11)";
  var backgroundColor3 = "rgba(36, 245,11, 0.5)";

  //uva
  var borderColor4 = "rgb(167, 35, 217)";
  var backgroundColor4 = "rgba(167, 35, 217, 0.5)";

  //Verde Azulado
  var borderColor5 = "rgb(39, 197, 200)";
  var backgroundColor5 = "rgba(39, 197, 200, 0.5)";

  //rosa
  var borderColor6 = "rgb(219, 32, 119)";
  var backgroundColor6 = "rgba(219, 32, 119, 0.5)";

  var borderColor7 = "rgb(248, 0,0)";
  var backgroundColor7 = "rgb(248, 0,0 , 0.5)";

  var linha_vertical_data = [];
  var linha_vertical_data2 = [];
  var linha_vertical_dados3 = [];
  var linha_vertical_mm = [];
  var linha_vertical_vmm = [];

  function getData_observed_number(linguagem){
    return {
      legenda,
      datasets: [
        {
          label: t("dashboard.graficos.titulo_variacao_mm"),
          data: dados_variacao_media_movel,
          borderColor: borderColor4,//borderColor6,
          backgroundColor: backgroundColor4,//backgroundColor6,
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        }
      ],
      
    };
  }

  function getData_(linguagem){
    return {
      legenda,
      datasets: [
        {
          label: t("dashboard.graficos.titulo_atendimento_totais"),
          data: dados,
          backgroundColor: 'rgba(255, 99, 132, 1.0)',
        }
      ],
    };
  }

  function getData2_(linguagem){
    return {
      legenda,
      datasets: [
        {
          label: t("dashboard.graficos.titulo_atendimento_gripais"),
          data: dados2,
          backgroundColor: 'rgba(53, 162, 235, 1.0)',
        },
        
      ],
    };
  }

  function getDataMediaMovel(linguagem){
    return {
      legenda2,
      datasets: [
        {
          label: t("dashboard.graficos.legenda_mm.1"),
          type: "line",
          data: dados_media_movel,
          borderColor: 'rgba(190, 155, 37, 1)',
          backgroundColor: 'rgba(190, 155, 37, 1)',
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        },
        {
          label: t("dashboard.graficos.legenda_mm.2"),
          data: dados3,
          borderColor: borderColor6,//borderColor6,borderColor4,
          backgroundColor: backgroundColor6,//backgroundColor6,//backgroundColor4,
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        },
      ],
    };
  }

  function getData_o_num(linguagem){
    return {
      legenda,
      datasets: [
        {
          fill: true,
          label: t("dashboard.graficos.titulo_atendimento_gripais"),
          data: dados_o_num,
          borderColor: borderColor,
          backgroundColor: backgroundColor,
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        },
        {
          fill: true,
          label: t("dashboard.graficos.titulo_limite"),
          data: dados_u_b_thr,
          borderColor: borderColor2,
          backgroundColor: backgroundColor2,
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        },
      ],
      
    };
  }

  function getData_excess_thr(linguagem){
    return {
      legenda,
      datasets: [
        {
          label: t("dashboard.graficos.titulo_excesso"),
          data: dados_e_h_estimate,
          borderColor: borderColor7,
          backgroundColor: backgroundColor7,
          borderWidth: 1,
          pointBorderWidth: 1,
          pointRadius: 1,
        }
      ],
      
    };
  }

  const [modal1Show, setModal1Show] = useState(false);
  const [modal2Show, setModal2Show] = useState(false);
  const [modal3Show, setModal3Show] = useState(false);
  const [modal4Show, setModal4Show] = useState(false);
  const [modal5Show, setModal5Show] = useState(false);
  const [modal6Show, setModal6Show] = useState(false);

  const [data_observed_number, setData_observed_number] = useState(getData_observed_number(props.data));

  const [data, setData] = useState(getData_(props.data));

  const [data2, setData2] = useState(getData2_(props.data));

  const [dataMediaMovel, setDataMediaMovel] = useState(getDataMediaMovel(props.data));
  
  const [data_o_num, setData_o_num] = useState(getData_o_num(props.data));

  const [data_excess_thr, setData_excess_thr] = useState(getData_excess_thr(props.data));

  const [markers, setMakers] = useState([])
  const [municipioSelecionado, setMunicipioSelecionado] = useState(t("dashboard.todos"))
  const [campoOrdem, setCampoOrdem] = useState("municipio");
  const [decrescente, setDecrescente] = useState(false);
  const [dataSelecionada, setDataSelecionada] = useState(datas[4]);
  const [idxDataSelecionada, setIdxDataSelecionada] = useState(4)
  const [maiorTaxa, setMaiorTaxa] = useState(0)
  const [menorTaxa, setMenorTaxa] = useState(0)

  async function filtrarMunicipio(cod_ibge, pintaCirculo, linguagem){

    if(filtrandoMunicipio)
      return;
    
    map.current.closePopup();
    filtrandoMunicipio = true;

    var municipio_sel = '';
    dados = [];
    dados2 = [];
    dados3 = [];
    dados4 = [];
    dados_media_movel = [];
    dados_variacao_media_movel = [];

    max_data_excess_thr = null;
    max_data_media_movel = null;
    max_data = null;
    max_data2 = null;
    max_dados3 = null;
    max_mm = null;
    max_vmm = null;
    max_p_e_h_estimate = null;
    max_e_h_estimate = null;
    max_u_b_thr = null;
    max_e_thr = null;
    max_o_num = null;

    linha_vertical_data = [];
    linha_vertical_data2 = [];
    linha_vertical_dados3 = [];
    linha_vertical_mm = [];
    linha_vertical_vmm = [];

    //console.log("Filtrar Municipio");
    if(pintaCirculo){
      if(layerOld != null){
        layerOld.setStyle({weight: 0.5, color:layerOld["fillColor"]});
        layerOld = null;   
      } 
      map.current.closePopup();
    }

    if(cod_ibge === "Todos" || cod_ibge === "All") 
    {
      console.log("filtrar todos");

      setMunicipioSelecionado(cod_ibge);
      var acumulado_gripal = 0; 
      dados_totais.forEach(function (dado){
        var obj = {};
        obj['data'] = dado["date"];
        obj['total'] = dado["total_geral"];
        dados.push(obj);

        if(max_data == null || max_data < dado["total_geral"])
          max_data = dado["total_geral"];
      
        var obj2 = {};
        obj2['data'] = dado["date"];
        obj2['total'] = dado["total_gripal"];
        dados2.push(obj2);

        if(max_data2 == null || max_data2 < dado["total_gripal"])
          max_data2 = dado["total_gripal"];

        var obj3 = {};
        obj3['data'] = dado["date"];
        obj3['total'] = (dado["total_gripal"] / dado["total_geral"]) * 100;
        dados3.push(obj3);

        if(max_dados3 == null || max_dados3 < ((dado["total_gripal"] / dado["total_geral"]) * 100))
          max_dados3 = (dado["total_gripal"] / dado["total_geral"]) * 100;

        acumulado_gripal += dado["total_gripal"];
        var obj4 = {};
        obj4['data'] = dado["date"];
        obj4['total'] = acumulado_gripal;
        dados4.push(obj4);

        var obj5 = {};
        obj5['data'] = dado["date"];
        obj5['total'] = dado["media_movel"];
        dados_media_movel.push(obj5);

        if(max_mm == null || max_mm < dado["media_movel"])
          max_mm = dado["media_movel"];

        var obj6 = {};
        obj6['data'] = dado["date"];
        obj6['total'] = dado["variacao_media_movel"];
        dados_variacao_media_movel.push(obj6);

        if(max_vmm == null || max_vmm < dado["variacao_media_movel"])
          max_vmm = dado["variacao_media_movel"];
      });

      dados_o_num = [];
      dados_e_thr = [];
      dados_u_b_thr = [];
      dados_e_h_estimate = [];
      dados_p_e_h_estimate = [];
      dados_totais_sesab.forEach(function (dado){
        var obj = {};
        obj['data'] = dado["date"];
        obj['total'] = dado["observed_number"];
        dados_o_num.push(obj);

        if(max_o_num == null || max_o_num < dado["observed_number"])
          max_o_num = dado["observed_number"];
      
        var obj2 = {};
        obj2['data'] = dado["date"];
        obj2['total'] = dado["exceeds_threshold"];
        dados_e_thr.push(obj2);

        if(max_e_thr == null || max_e_thr < dado["exceeds_threshold"])
          max_e_thr = dado["exceeds_threshold"];
      
        /*var obj3 = {};
        obj3['data'] = dado["date"];
        obj3['total'] = (dado["total_gripal"] / dado["total_geral"]) * 100;
        dados3.push(obj3);
      
        acumulado_gripal += dado["total_gripal"];
        var obj4 = {};
        obj4['data'] = dado["date"];
        obj4['total'] = acumulado_gripal;
        dados4.push(obj4);*/
      
        var obj5 = {};
        obj5['data'] = dado["date"];
        obj5['total'] = dado["upper_bound_threshold"];
        dados_u_b_thr.push(obj5);

        if(max_u_b_thr == null || max_u_b_thr < dado["upper_bound_threshold"])
          max_u_b_thr = dado["upper_bound_threshold"];
      
        var obj6 = {};
        obj6['data'] = dado["date"];
        obj6['total'] = dado["excess_higher_estimate"] > 0 ? dado["excess_higher_estimate"] : 0;
        dados_e_h_estimate.push(obj6);

        if(max_e_h_estimate == null || (dado["excess_higher_estimate"] > 0 ? dado["excess_higher_estimate"] : 0))
          max_e_h_estimate = dado["excess_higher_estimate"] > 0 ? dado["excess_higher_estimate"] : 0;

        var obj7 = {};
        obj7['data'] = dado["date"];
        obj7['total'] = dado["percent_excess_higher_estimate"];
        dados_p_e_h_estimate.push(obj7);

        if(max_p_e_h_estimate == null || dado["percent_excess_higher_estimate"])
          max_p_e_h_estimate = dado["percent_excess_higher_estimate"];
      
      });
      
    }
    else
    {
      /*if(circleOld != null && pintaCirculo){
        circleOld.setStyle({stroke:false, color:circleOld["fillColor"]});
        circleOld = null; 
      }*/

      var encontrou = false;
      var encontrouSesab = false;
      dados_municipios["municipios"].forEach(function(municipio) {
        if(municipio["cod_ibge"] === cod_ibge || municipio["municipio"] == cod_ibge){
          encontrou = true;


          cod_ibge = municipio["cod_ibge"];
          
          /*if(layerOld != null){
            layerOld.setStyle({weight: 0.5, color:layerOld["fillColor"]});
            layerOld = null;   
          } */
  
          if(pintaCirculo){
              /*if(layerOld != null){
                var cor = layerOld["fillColor"];
                for(let i = 0; i < dados_municipios_por_data['municipios'].length; i++){
                  if(layerOld._map.["_popup"].includes(dados_municipios_por_data['municipios'][i]['municipio'])){
                    cor = layerOld["fillColor"];
                    break;
                  }
                }
                layerOld.setStyle({weight: 0.5, color:cor});
                layerOld = null;   
              } */
              /* REmoção da taxa de atendimento do
              Object.keys(shapeFileMapaTaxaAtendimento["_layers"]).forEach((shape) => {
                if(parseInt(municipio["cod_ibge"]) == parseInt(shapeFileMapaTaxaAtendimento["_layers"][shape]["feature"]["properties"]["CD_MUN"])){     
                  shapeFileMapaTaxaAtendimento["_layers"][shape].setStyle({weight: 3.5, color: corSelecao});
                  if(layerAtiva === "")
                    layerOld = shapeFileMapaTaxaAtendimento["_layers"][shape];
                }

                for(let i = 0 ; i < listBindPopup.length; i++){
                  if(parseInt(shapeFileMapaTaxaAtendimento["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                    shapeFileMapaTaxaAtendimento["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
                    break;
                  }
                }
              }); */

              Object.keys(shapeFileMapaMediaMovel["_layers"]).forEach((shape) => {
                if(cod_ibge == shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                  shapeFileMapaMediaMovel["_layers"][shape].setStyle({weight: 3.5, color: corSelecao});
                  if(layerAtiva === "mm")
                    layerOld = shapeFileMapaMediaMovel["_layers"][shape];
                }

                for(let i = 0 ; i < listBindPopup.length; i++){
                  if(parseInt(shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                    shapeFileMapaMediaMovel["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
                    break;
                  }
                }
              });
          }

          /*
          if(shapeFileMapa != null){
            console.log(map.current);
            Object.keys(shapeFileMapa["_layers"]).forEach((shape) => {
              if(municipio["cod_ibge"] == shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                console.log(municipio["cod_ibge"]);
                console.log(shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"]);
                shapeFileMapa["_layers"][shape].setStyle({weight: 3.5, color:'white'});
                layerOld = shapeFileMapa["_layers"][shape]; 
              }
            });
          } */
    
          var cod_ibge_selecionado = String(municipio["cod_ibge"]);
          cod_ibge_selecionado = cod_ibge_selecionado.substring(0, 6);

          setMunicipioSelecionado(municipio["municipio"]);
          municipio_sel = municipio["municipio"];
          
          //map.current.setView([municipio["latitude"],municipio["longitude"]], 8, { animation: true });

          if(municipio["latitude"] != null){
            var latLon = L.latLng(municipio["latitude"],municipio["longitude"]);
            var bounds = latLon.toBounds(500); // 500 = metres
            map.current.panTo(latLon).fitBounds(bounds);
            bounds = latLon.toBounds(350000); // 500 = metres
            map.current.panTo(latLon).fitBounds(bounds);
          }

          var acumulado_gripal = 0;
          municipio["atendimentos"].forEach(function(atendimento){
            var obj = {};
            obj['data'] = atendimento["data"];
            obj['total'] = atendimento["total_geral"];
            dados.push(obj);

            if(max_data == null || max_data < atendimento["total_geral"])
              max_data = atendimento["total_geral"];
      
            var obj2 = {};
            obj2['data'] = atendimento["data"];
            obj2['total'] = atendimento["total_gripal"];
            dados2.push(obj2);

            if(max_data2 == null || max_data2 < atendimento["total_gripal"])
              max_data2 = atendimento["total_gripal"];

            var obj3 = {};
            obj3['data'] = atendimento["data"];
            obj3['total'] = (atendimento["total_gripal"] / atendimento["total_geral"]) * 100;
            dados3.push(obj3);

            if(max_dados3 == null || max_dados3 < ((atendimento["total_gripal"] / atendimento["total_geral"]) * 100))
              max_dados3 = (atendimento["total_gripal"] / atendimento["total_geral"]) * 100;

            acumulado_gripal += atendimento["total_gripal"];
            var obj4 = {};
            obj4['data'] = atendimento["data"];
            obj4['total'] = acumulado_gripal;
            dados4.push(obj4);

            var obj5 = {};
            obj5['data'] = atendimento["data"];
            obj5['total'] = atendimento["media_movel"];
            dados_media_movel.push(obj5);

            if(max_mm == null || max_mm < atendimento["media_movel"])
              max_mm = atendimento["media_movel"];

            var obj6 = {};
            obj6['data'] = atendimento["data"];
            obj6['total'] = atendimento["variacao_media_movel"];
            dados_variacao_media_movel.push(obj6);

            if(max_vmm == null || max_vmm < atendimento["variacao_media_movel"])
              max_vmm = atendimento["variacao_media_movel"];

          });          
        }
      }); 
      
      //console.log(dados_municipios_sesab["municipios"]);
      //console.log(cod_ibge);

      dados_municipios_sesab["municipios"].forEach(function(municipio) {
        if(municipio["cod_ibge"] === cod_ibge){
          encontrouSesab = true;
          /*if(layerOld != null){
            layerOld.setStyle({weight: 0.5, color:layerOld["fillColor"]});
            layerOld = null;   
          } */
  
          if(pintaCirculo){
            if(shapeFileMapaExcesso != null){
              /*Object.keys(shapeFileMapaExcesso["_layers"]).forEach((shape) => {
                if(municipio["cod_ibge"] == shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                  shapeFileMapaExcesso["_layers"][shape].setStyle({weight: 3.5, color: props.theme === "dark" ? 'white' : 'gray'});
                  if(layerAtiva === "ex")
                    layerOld = shapeFileMapaExcesso["_layers"][shape];
                }

                for(let i = 0 ; i < listBindPopup.length; i++){
                  console.log(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]);
                  parseInt(listBindPopup[i]["cod_mun"]);
                  if(parseInt(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                    shapeFileMapaExcesso["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
                    break;
                  }
                }
              });*/

              Object.keys(shapeFileMapaExcesso["_layers"]).forEach((shape) => {
                if(municipio["cod_ibge"] == shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                  shapeFileMapaExcesso["_layers"][shape].setStyle({weight: 3.5, color: corSelecao});
                  if(layerAtiva === "ex")
                    layerOld = shapeFileMapaExcesso["_layers"][shape];
                }

                for(let i = 0 ; i < listBindPopup2.length; i++){
                  if(parseInt(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                    shapeFileMapaExcesso["_layers"][shape].bindPopup(listBindPopup2[i]["conteudo"]);
                    break;
                  }
                }
              });
            }
          }

          /*
          if(shapeFileMapa != null){
            console.log(map.current);
            Object.keys(shapeFileMapa["_layers"]).forEach((shape) => {
              if(municipio["cod_ibge"] == shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                console.log(municipio["cod_ibge"]);
                console.log(shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"]);
                shapeFileMapa["_layers"][shape].setStyle({weight: 3.5, color:'white'});
                layerOld = shapeFileMapa["_layers"][shape]; 
              }
            });
          } */
    
          var cod_ibge_selecionado = String(municipio["cod_ibge"]);
          cod_ibge_selecionado = cod_ibge_selecionado.substring(0, 6);

          //setMunicipioSelecionado(municipio["municipio"]);
          //municipio_sel = municipio["municipio"];
          
          //map.current.setView([municipio["latitude"],municipio["longitude"]], 8, { animation: true });

          dados_o_num = [];
          dados_e_thr = [];
          dados_u_b_thr = [];
          dados_e_h_estimate = [];
          dados_p_e_h_estimate = [];
          
          municipio["amostras"].forEach(function(amostra){
            var obj = {};
            obj['data'] = amostra["data"];
            obj['total'] = amostra["observed_number"];
            dados_o_num.push(obj);

            if(max_o_num == null || max_o_num < amostra["observed_number"])
              max_o_num = amostra["observed_number"];
      
            var obj2 = {};
            obj2['data'] = amostra["data"];
            obj2['total'] = amostra["exceeds_threshold"];
            dados_e_thr.push(obj2);

            if(max_e_thr == null || max_e_thr < amostra["exceeds_threshold"])
              max_e_thr = amostra["exceeds_threshold"];

            var obj3 = {};
            obj3['data'] = amostra["data"];
            obj3['total'] = amostra["upper_bound_threshold"];
            dados_u_b_thr.push(obj3);

            if(max_u_b_thr == null || max_u_b_thr < amostra["upper_bound_threshold"])
              max_u_b_thr = amostra["upper_bound_threshold"];

            var obj5 = {};
            obj5['data'] = amostra["data"];
            obj5['total'] = amostra["excess_higher_estimate"] > 0 ? amostra["excess_higher_estimate"] : 0;
            dados_e_h_estimate.push(obj5);

            if(max_e_h_estimate == null || max_e_h_estimate < (amostra["excess_higher_estimate"] > 0 ? amostra["excess_higher_estimate"] : 0))
            max_e_h_estimate = amostra["excess_higher_estimate"] > 0 ? amostra["excess_higher_estimate"] : 0;

            var obj6 = {};
            obj6['data'] = amostra["data"];
            obj6['total'] = amostra["percent_excess_higher_estimate"];
            dados_p_e_h_estimate.push(obj6);

            if(max_p_e_h_estimate == null || max_p_e_h_estimate < amostra["percent_excess_higher_estimate"])
             max_p_e_h_estimate = amostra["percent_excess_higher_estimate"];

          });          
        }
      });

      if(!encontrou) return;
    }

    /*
    linha_vertical_data = getLinhaInterna(dataSelecionada, max_data);
    linha_vertical_data2 = getLinhaInterna(dataSelecionada, max_data2);
    linha_vertical_dados3 = getLinhaInterna(dataSelecionada, max_dados3);
    linha_vertical_mm = getLinhaInterna(dataSelecionada, max_mm);
    linha_vertical_vmm = getLinhaInterna(dataSelecionada, max_vmm); */
    linha_vertical_data = [];
    linha_vertical_data2 = [];
    linha_vertical_dados3 = [];
    linha_vertical_mm = [];
    linha_vertical_vmm = [];


    dados = Object.fromEntries(
      dados.map(({data, total}) => [data, total])
    );
    
    dados2 = Object.fromEntries(
      dados2.map(({data, total}) => [data, total])
    );

    dados3 = Object.fromEntries(
      dados3.map(({data, total}) => [data, total])
    );

    dados4 = Object.fromEntries(
      dados4.map(({data, total}) => [data, total])
    );

    dados_media_movel = Object.fromEntries(
      dados_media_movel.map(({data, total}) => [data, total])
    );

    dados_variacao_media_movel = Object.fromEntries(
      dados_variacao_media_movel.map(({data, total}) => [data, total])
    );

    setData(
      getData_(linguagem)
    );

    setData2(
      getData2_(linguagem)
    );

    //const labels_linha = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

    setData_observed_number(
      getData_observed_number(linguagem)
    );

    setDataMediaMovel(
      getDataMediaMovel(linguagem)
    );


    if(encontrouSesab || (cod_ibge === "Todos" || cod_ibge === "All") ){
      dados_o_num = Object.fromEntries(
        dados_o_num.map(({data, total}) => [data, total])
      );
      
      dados_e_thr = Object.fromEntries(
        dados_e_thr.map(({data, total}) => [data, total])
      );
      
      dados_u_b_thr = Object.fromEntries(
        dados_u_b_thr.map(({data, total}) => [data, total])
      );
      
      dados_e_h_estimate = Object.fromEntries(
        dados_e_h_estimate.map(({data, total}) => [data, total])
      );
      
      dados_p_e_h_estimate = Object.fromEntries(
        dados_p_e_h_estimate.map(({data, total}) => [data, total])
      ); 
      
      setData_o_num(
        getData_o_num(linguagem)
      )
      
      setData_excess_thr(
        getData_excess_thr(linguagem)
      )
    }
    
    //console.log("filtrar Municipio");
    getMakers(municipio_sel, true, linguagem, false, "");    

    filtrandoMunicipio = false;
  }


  useImperativeHandle(ref, (linguagem) => ({

    refreshMap(linguagem){
      if((map.current == null))
        return;
      if(layerTile != null){
        map.current.removeLayer(layerTile);
      }

      var url = linguagem === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

      const defaultCenter = position;

      layerTile = L.tileLayer(url, {
        zoomControl: true,
        zoomSnap: zoomSnap_,
        zoomDelta: zoomSnap_,
        wheelPxPerZoomLevel: wheelPxPerZoomLevel_,
        defaultZoom: defaultZoom,
        maxZoom: 18,
        id: 'mapbox.streets'
      });

      map.current.setView(defaultCenter, defaultZoom);
      layerTile.addTo(map.current);

      corSelecao = (linguagem === "dark" ? "white" : "gray");
    },
 

    refreshGraph(linguagem){
      //let url = ;
      if(layerGroup != null)
        map.current.removeLayer(layerGroup);

      //console.log("RefreshGraph");
      //getMakers("", true, linguagem, true);   
      getData (dataSelecionada, linguagem, false);
      getData2(dataSelecionada, linguagem, false);
      setData(
        getData_(linguagem)
      );
  
      setData2(
        getData2_(linguagem)
      );
  
      //const labels_linha = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  
      setData_observed_number(
        getData_observed_number(linguagem)
      );
  
      setDataMediaMovel(
        getDataMediaMovel(linguagem)
      );

      setData_o_num(
        getData_o_num(linguagem)
      )
      
      setData_excess_thr(
        getData_excess_thr(linguagem)
      )
  
      /*setDataVariacaoMediaMovel(
        {
          legenda2,
          datasets: [
            {
              label: linguagem === 'pt' ? 'Variação Média Móvel' : 'Moving Average Variation',
              type: "line",
              data: dados_variacao_media_movel,
              backgroundColor: 'rgba(53, 162, 235, 1)',
            }
          ],
        }
        
      );*/
      criarLegenda(menorTaxa, maiorTaxa, layerAtiva, linguagem);

      var overlays = {};

      //overlays[linguagem === "pt" ? 'Taxa de Atendimentos Gripais' :  'Flu Rate Encounters'] = shapeFileMapaTaxaAtendimento;
      overlays[t("dashboard.titulo_mapa_taxa_crescimento")] = shapeFileMapaMediaMovel;
      overlays[t("dashboard.titulo_mapa_atendimentos_excedentes")] = shapeFileMapaExcesso;

      layerControl.remove();
      layerControl = L.control.layers(null, overlays, {collapsed:false}).addTo(map.current);

    }
  }));

  function preparaMesAno(data){
    return data.substring(5,7) +"/"+ data.substring(0,4);
  }

  function geraEspacoHTML(quantidade){
    var saida = "";
    for(let i = 0 ; i <  quantidade; i ++){
      saida += "&nbsp;";
    }
    return saida;
  }

  function getMakers (nomeMunicipio, somenteMapa, linguagem, pintaCirculo, variavel) {
      var maior_taxa = 0;
      var menor_taxa = 0;

      /*if(circleMarkers.length <= 0){*/
        var tempCircleMarkers = [];
        var tempMakers = [];
        var tempMakersMediaMovel = [];
        var tempMakersSesab = [];
        
        if(dados_municipios_por_data_sesab != null){

          
          for(let i = 0; i < dados_municipios_por_data_sesab["municipios"].length; i++)
          {
            var nome = "";
            Object.keys(shapeFileMapaExcesso["_layers"]).forEach((shape) => {
              if(parseInt(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(dados_municipios_por_data_sesab["municipios"][i]["cod_ibge"])){
                nome = shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["NM_MUN"];
              }
            });
            tempMakersSesab.push({
              "cod_ibge" : dados_municipios_por_data_sesab['municipios'][i]["cod_ibge"],
              "municipio" : nome,
              "observed_number" :dados_municipios_por_data_sesab['municipios'][i]["observed_number"],
              "exceeds_threshold" : dados_municipios_por_data_sesab['municipios'][i]["exceeds_threshold"],
              "upper_bound_threshold" : dados_municipios_por_data_sesab['municipios'][i]["upper_bound_threshold"],
              "excess_higher_estimate" : dados_municipios_por_data_sesab['municipios'][i]["excess_higher_estimate"],
              "percent_excess_higher_estimate" : dados_municipios_por_data_sesab['municipios'][i]["percent_excess_higher_estimate"],
              "color_indicator" : dados_municipios_por_data_sesab['municipios'][i]["color_indicator"],
              "data" : dados_municipios_por_data_sesab["data"], 
            })
          }
        }

          Object.keys(shapeFileMapaExcesso["_layers"]).forEach((shape) => {
            
            var cor = "#545453"; 
            var corContorno = cor;
            if(pintaCirculo){
              for(let x= 0; x < tempMakersSesab.length; x++){
                var encontrou_x = false;
                if(parseInt(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(tempMakersSesab[x]["cod_ibge"])){        
                    if(tempMakersSesab[x]["observed_number"] != null){
                      switch(tempMakersSesab[x]["color_indicator"]){
                        case 3: {cor = "red"; break;}
                        case 2: {cor = "yellow"; break;}
                        case 1: {cor = "green"; break;}
                      }
                    }
                    corContorno = cor;
                    if(municipioSelecionado === shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["NM_MUN"]){
                      corContorno = "white";
                    }
                    encontrou_x = true;
                }
                if(encontrou_x){
                  break;
                }
              }

              shapeFileMapaExcesso["_layers"][shape].setStyle({weight: 0.5 ,color:corContorno, fillColor:cor});
            }
          });

          //tempMakersMediaMovel

          for(let x = 0; x < dados_municipios["municipios"].length; x++){
            for(let z = 0; z < dados_municipios["municipios"][x]["atendimentos"].length; z++){                  
              if(dados_municipios["municipios"][x]["atendimentos"][z]["data"] == data_local){
                var excesso_ = null;
                var limite_superior_ = null;
                for(let y= 0; y < tempMakersSesab.length; y++){
                  var encontrou_y = false;
                  if(parseInt(dados_municipios["municipios"][x]["cod_ibge"]) == parseInt(tempMakersSesab[y]["cod_ibge"])){        
                      excesso_ = tempMakersSesab[y]["excess_higher_estimate"];
                      limite_superior_ = tempMakersSesab[y]["upper_bound_threshold"];
                      encontrou_y = true;
                  }
                  if(encontrou_y){
                    break;
                  }
                }

                tempMakersMediaMovel.push({
                  "cod_ibge" : dados_municipios["municipios"][x]["cod_ibge"],
                  "municipio" : dados_municipios["municipios"][x]["municipio"],
                  "populacao" : dados_municipios["municipios"][x]["populacao"],
                  "cor_media_movel" : dados_municipios["municipios"][x]["atendimentos"][z]["cor_media_movel"],
                  "gripais_100milhab" : dados_municipios["municipios"][x]["atendimentos"][z]["gripais_100milhab"],
                  "media_movel" : dados_municipios["municipios"][x]["atendimentos"][z]["media_movel"],
                  "taxagripais_atendtotais" : dados_municipios["municipios"][x]["atendimentos"][z]["taxagripais_atendtotais"],
                  "total_geral" : dados_municipios["municipios"][x]["atendimentos"][z]["total_geral"],
                  "total_gripal" : dados_municipios["municipios"][x]["atendimentos"][z]["total_gripal"],
                  "variacao_media_movel" : dados_municipios["municipios"][x]["atendimentos"][z]["variacao_media_movel"] != null  ? dados_municipios["municipios"][x]["atendimentos"][z]["variacao_media_movel"].toFixed(2) : null,
                  "data": dados_municipios_por_data['data'],
                  "excesso" : excesso_,
                  "limite_superior" : limite_superior_,
                  //find para encontrar o excesso e limite superior
                });
                break;
              }  
            }
          }
          
          if(dados_municipios_por_data != null){
              maior_taxa = dados_municipios_por_data["max"];
              menor_taxa = dados_municipios_por_data["min"];

              for(let i = 0; i < dados_municipios_por_data["municipios"].length; i++)
              {
                //console.log(dados_municipios_por_data["municipios"]);
                tempMakers.push({
                  "cod_ibge" : dados_municipios_por_data['municipios'][i]["cod_ibge"],
                  "coordenadas" : [dados_municipios_por_data['municipios'][i]["latitude"],dados_municipios_por_data['municipios'][i]["longitude"]],
                  "municipio" : dados_municipios_por_data['municipios'][i]["municipio"],
                  "populacao" : dados_municipios_por_data['municipios'][i]["populacao"],
                  "escolarizacao" : dados_municipios_por_data['municipios'][i]["escolarizacao"],
                  "idhm" : dados_municipios_por_data['municipios'][i]["idhm"],
                  "ibp" : dados_municipios_por_data['municipios'][i]["ibp"],
                  "pib2020" : dados_municipios_por_data['municipios'][i]["pib2020"],
                  "densidade" : dados_municipios_por_data['municipios'][i]["densidade"],
                  "taxa" : parseFloat(dados_municipios_por_data['municipios'][i]["taxagripais_atendtotais"]).toFixed(2),
                  "total_gripal" : dados_municipios_por_data['municipios'][i]["total_gripal"],
                  "total_geral" : dados_municipios_por_data['municipios'][i]["total_geral"],
                  "cor" : dados_municipios_por_data['municipios'][i]["cor"],
                  "data": dados_municipios_por_data['data']
                })
              }
          }
        
          criarLegenda(menor_taxa, maior_taxa, layerAtiva, linguagem);
          textoLegenda = '<table><tr><th  bgcolor="#009827">&nbsp</th><th  bgcolor="#FAFF00">&nbsp</th><th bgcolor="#FF1200">&nbsp</th></tr><tr><td style="text-align:left">'+parseFloat(menor_taxa).toFixed(2)+'</td><td style="text-align:center">'+parseFloat(((menor_taxa+maior_taxa)/2)).toFixed(2)+'</td><td style="text-align:right">'+parseFloat(maior_taxa).toFixed(2)+'</td></tr>';
          setMenorTaxa(menor_taxa);
          setMaiorTaxa(maior_taxa);
        
          listBindPopup = [];
          listBindPopup2 = [];

          /*
          for(let i = 0; i < tempMakers.length; i++){
            var cor = tempMakers[i]["cor"];
            var ativaStroke = false;

            listBindPopup.push({
              "cod_mun" : tempMakers[i]["cod_ibge"],
              "conteudo" : tempMakers[i]["taxa"] == "NaN" ? (linguagem === 'pt' ? `<h5>${tempMakers[i]["municipio"]}</h5> Sem Informações` : `<h5>${tempMakers[i]["municipio"]}</h5> No informations`) : linguagem === 'pt' ?
              `<h5>${tempMakers[i]["municipio"]}</h5>  Taxa de atendimentos gripais ${tempMakers[i]["taxa"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        População ${tempMakers[i]["populacao"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Semana epidemiológica  ${preparaMesAno(tempMakers[i]["data"])}
                                        ` : `<h5>${tempMakers[i]["municipio"]}</h5> Flu Encounters Rate ${tempMakers[i]["taxa"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Population ${tempMakers[i]["populacao"]}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Epidemiological Week ${preparaMesAno(tempMakers[i]["data"])} 
                                        `
            });
            
          } */

          for(let i = 0; i < tempMakersMediaMovel.length; i++){
            var semana_ep = 0;
            for(let idx_data = 0; idx_data < semanas_epidemiologicas.length; idx_data++){
              if(semanas_epidemiologicas[idx_data]["data"] === tempMakersMediaMovel[i]["data"]){
                semana_ep = semanas_epidemiologicas[idx_data]["semana"];
                break;
              }
            }

            listBindPopup.push({
              "cod_mun" : tempMakersMediaMovel[i]["cod_ibge"],
              "conteudo" : tempMakersMediaMovel[i]["variacao_media_movel"] == "NaN" || tempMakersMediaMovel[i]["variacao_media_movel"] == null ? (linguagem === 'pt' ? `<h5>${tempMakersMediaMovel[i]["municipio"]}</h5> Sem Informação` : `<h5>${tempMakersMediaMovel[i]["municipio"]}</h5> No information`) : linguagem === 'pt' ?
              `<h5>${tempMakersMediaMovel[i]["municipio"]}</h5>  ${t("dashboard.titulo_mapa_taxa_crescimento")} ${fixaCasasDecimais(tempMakersMediaMovel[i]["variacao_media_movel"],2)}% 
                                        ${t("dashboard.table.col2")} ${tempMakersMediaMovel[i]["populacao"]} 
                                        ${geraEspacoHTML(80 - (tempMakersMediaMovel[i]["populacao"].toString().length))}
                                        Semana epidemiológica  ${semana_ep} 
                                        ${geraEspacoHTML(60 - semana_ep.toString().length)}
                                        ${preparaMesAno(tempMakersMediaMovel[i]["data"])}
                                        ` : `<h5>${tempMakersMediaMovel[i]["municipio"]}</h5> ${t("dashboard.titulo_mapa_taxa_crescimento")} ${fixaCasasDecimais(tempMakersMediaMovel[i]["variacao_media_movel"],2)}% 
                                        
                                        ${t("dashboard.table.col2")} ${tempMakersMediaMovel[i]["populacao"]}  
                                        ${geraEspacoHTML(80 - (tempMakersMediaMovel[i]["populacao"].toString().length))}
                                        Epidemiological Week ${semana_ep}
                                        ${geraEspacoHTML(65 - semana_ep.toString().length)}
                                        ${preparaMesAno(tempMakersMediaMovel[i]["data"])} 
                                        `
            });
            
          } 

          for (let i = 0; i < tempMakersSesab.length; i++){

              var semana_ep = 0;
              for(let idx_data = 0; idx_data < semanas_epidemiologicas.length; idx_data++){
                if(semanas_epidemiologicas[idx_data]["data"] === tempMakersSesab[i]["data"]){
                  semana_ep = semanas_epidemiologicas[idx_data]["semana"];
                  break;
                }
              }

              listBindPopup2.push({
                "cod_mun" : tempMakersSesab[i]["cod_ibge"],
                "conteudo" : tempMakersSesab[i]["observed_number"] == null ? linguagem === 'pt' ? `<h5>${tempMakersSesab[i]["municipio"]}</h5> Sem Informações` : `<h5>${tempMakersSesab[i]["municipio"]}</h5> No informations` :  linguagem === 'pt' ?
                `<h5>${tempMakersSesab[i]["municipio"]}</h5> ${t("dashboard.graficos.titulo_atendimento_gripais")} ${tempMakersSesab[i]["observed_number"]} 
                                          ${geraEspacoHTML(59 - (tempMakersSesab[i]["observed_number"].toString().length))}
                                          ${t("dashboard.graficos.titulo_limite")} ${tempMakersSesab[i]["upper_bound_threshold"]} 
                                          ${geraEspacoHTML(39 - (tempMakersSesab[i]["upper_bound_threshold"].toString().length))}                     
                                          ${t("dashboard.graficos.titulo_excesso")} ${tempMakersSesab[i]["excess_higher_estimate"]} 
                                          ${geraEspacoHTML(25 - (tempMakersSesab[i]["excess_higher_estimate"].toString().length))} 
                                          Semana epidemiológica ${semana_ep} 
                                          ${geraEspacoHTML(60 - semana_ep.toString().length)}
                                          ${preparaMesAno(tempMakersSesab[i]["data"])}
                                          ` : `<h5>${tempMakersSesab[i]["municipio"]}</h5> ${t("dashboard.graficos.titulo_atendimento_gripais")}  ${tempMakersSesab[i]["observed_number"]} 
                                          ${geraEspacoHTML(72 - (tempMakersSesab[i]["observed_number"].toString().length))}
                                          ${t("dashboard.graficos.titulo_limite")} ${tempMakersSesab[i]["upper_bound_threshold"]} 
                                          ${geraEspacoHTML(50 - (tempMakersSesab[i]["upper_bound_threshold"].toString().length))}
                                          ${t("dashboard.graficos.titulo_excesso")} ${tempMakersSesab[i]["excess_higher_estimate"]}  
                                          ${geraEspacoHTML(35 - (tempMakersSesab[i]["excess_higher_estimate"].toString().length))}
                                          Epidemiological Week ${semana_ep} 
                                          ${geraEspacoHTML(65 - semana_ep.toString().length)}
                                          ${preparaMesAno(tempMakersSesab[i]["data"])} 
                                          `
            });
          }
          
          if(shapeFileMapaMediaMovel != null || (pintaCirculo && shapeFileMapaMediaMovel != null)){

            /*Object.keys(shapeFileMapaTaxaAtendimento["_layers"]).forEach((shape) => {
              if(pintaCirculo){
                
                for(let i = 0; i < tempMakers.length; i++){
                  if(tempMakers[i]["cod_ibge"] == shapeFileMapaTaxaAtendimento["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                    
                    var cor = tempMakers[i]["cor"];
                    
                    if(nomeMunicipio === shapeFileMapaTaxaAtendimento["_layers"][shape]["feature"]["properties"]["NM_MUN"]){
                      cor = '#fff';
                      layerOld = shapeFileMapaTaxaAtendimento["_layers"][shape];
                    }
                    
                    shapeFileMapaTaxaAtendimento["_layers"][shape].setStyle({color:cor, fillColor:tempMakers[i]["cor"]});
                    break;
                  }
                }
              }

              for(let i = 0 ; i < listBindPopup.length; i++){
                if(parseInt(shapeFileMapaTaxaAtendimento["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                  shapeFileMapaTaxaAtendimento["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
                  break;
                }
              }
            });*/

            Object.keys(shapeFileMapaMediaMovel["_layers"]).forEach((shape) => {
              if(pintaCirculo){     
                /*for(let i = 0; i < tempMakers.length; i++){
                  if(tempMakers[i]["cod_ibge"] == shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"]){
                    
                    var cor = tempMakers[i]["cor"];
                    
                    if(nomeMunicipio === shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["NM_MUN"]){
                      cor = '#fff';
                      layerOld = shapeFileMapaMediaMovel["_layers"][shape];
                    }
                    
                    shapeFileMapaMediaMovel["_layers"][shape].setStyle({color:cor, fillColor:tempMakers[i]["cor"]});
                    if(layerAtiva === "mm")
                      layerOld = shapeFileMapaMediaMovel["_layers"][shape];
                    break;
                  }
                }*/
              var encontrou_x = false;
              for(let x = 0; x < dados_municipios["municipios"].length; x++){
                if(shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"] == dados_municipios["municipios"][x]["cod_ibge"]){
                  for(let z = 0; z < dados_municipios["municipios"][x]["atendimentos"].length; z++){                  
                    if(dados_municipios["municipios"][x]["atendimentos"][z]["data"] == data_local){
                      var cor = dados_municipios["municipios"][x]["atendimentos"][z]["cor_media_movel"];
                      var corContorno = cor;
                      if(municipioSelecionado === shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["NM_MUN"]){
                        corContorno = "#fff";
                      }
                      shapeFileMapaMediaMovel["_layers"][shape].setStyle({weight: 0.5 ,color:corContorno, fillColor:cor});
                      encontrou_x = true;
                      break;
                    }  
                  }
                }
                if(encontrou_x)
                  break;
              }
            }
              for(let i = 0 ; i < listBindPopup.length; i++){
                if(parseInt(shapeFileMapaMediaMovel["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup[i]["cod_mun"])){
                  shapeFileMapaMediaMovel["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
                  break;
                }
              }

            });

            Object.keys(shapeFileMapaExcesso["_layers"]).forEach((shape) => {
              for(let i = 0 ; i < listBindPopup2.length; i++){
                if(parseInt(shapeFileMapaExcesso["_layers"][shape]["feature"]["properties"]["CD_MUN"]) == parseInt(listBindPopup2[i]["cod_mun"])){
                  if(listBindPopup2[i]["conteudo"] != "No Data" && listBindPopup2[i]["conteudo"] != "Sem Dados")
                    shapeFileMapaExcesso["_layers"][shape].bindPopup(listBindPopup2[i]["conteudo"]);
                  break;
                }
              }
            });
          } 

          //setMakers(tempMakers); 
          setMakers(tempMakersMediaMovel);    

      /*}*/
    
    return [...markers];
  }

  const getSemana=()=>{
    fetch('dados_semanas.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }
    )
      .then(function(response){
        //Limpa pontos anteriores
        return response.json();
      })
      .then(function(myJson) {
        semanas_epidemiologicas = myJson;
      });
}

  const getData=(dt, linguagem, pintaCirculo)=>{
    if(dt != undefined){
      fetch('BA/municipios_por_datas/dados_'+dt.replace(" 00:00:00", "")+'.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
      )
        .then(function(response){
          //Limpa pontos anteriores
          return response.json();
        })
        .then(function(myJson) {
          dados_municipios_por_data = myJson;
          data_local = dt;
          //console.log("getData");
          getMakers(municipioSelecionado, false, linguagem, pintaCirculo, "");
        });
    }
  }

  const getData2=(dt, linguagem, pintaCirculo)=>{
    if(dt != undefined){
      fetch('BA/municipios_por_datas/sesab/dados_'+dt.replace(" 00:00:00", "")+'_sesab.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
      )
        .then(function(response){
          //Limpa pontos anteriores
          return response.json();
        })
        .then(function(myJson) {
          dados_municipios_por_data_sesab = myJson;
          data_local = dt;
          //console.log("getData2");
          getMakers(municipioSelecionado, false, linguagem, pintaCirculo, "sesab");
        });
    }
  }

  function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }

  async function mudaData(idx){
    if(alterandoData)
      return;
    
    map.current.closePopup();

    alterandoData = true;  

    setIdxDataSelecionada(idx)
    setDataSelecionada(datas[idx])

    //console.log("mudaData");
    getData(datas[idx], props.data, layerAtiva === "mm");
    
    getData2(datas[idx], props.data, layerAtiva != "mm");

    /*
    linha_vertical_data = getLinhaInterna(datas[idx], max_data);
    linha_vertical_data2 = getLinhaInterna(datas[idx], max_data2);
    linha_vertical_dados3 = getLinhaInterna(datas[idx], max_dados3);
    linha_vertical_mm = getLinhaInterna(datas[idx], max_mm);
    linha_vertical_vmm = getLinhaInterna(datas[idx], max_vmm);*/

    linha_vertical_data = [];
    linha_vertical_data2 = [];
    linha_vertical_dados3 = [];
    linha_vertical_mm = [];
    linha_vertical_vmm = [];

    //await timeout(500);

    setData(
      getData_(props.data)
    );

    setData2(
      getData2_(props.data)
    );

    //const labels_linha = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

    setData_observed_number(
      getData_observed_number(props.data)
    );

    setDataMediaMovel(
      getDataMediaMovel(props.data)
    );

    setData_o_num(
      getData_o_num(props.data)
    )
    
    setData_excess_thr(
      getData_excess_thr(props.data)
    )

    /*setDataVariacaoMediaMovel(
      {
        legenda2,
        datasets: [
          {
            label: props.data === 'pt' ? 'Variação Média Móvel' : 'Moving Average Variation',
            type: "line",
            data: dados_variacao_media_movel,
            backgroundColor: 'rgba(53, 162, 235, 1)',
          }
        ],
      }
      
    );*/

    alterandoData = false;
  }


    if(props.login){
      return (
          <Container>
            <br></br>
            <br></br>
            <Row>
              <div>
                <Translator path="dashboard.data"/>: <Moment date={dataSelecionada} format='DD/MM/YYYY'></Moment>
                <br></br>            
                
                <input type={"range"} max={datas.length-1} min={0} /*defaultValue={0}*/ value={idxDataSelecionada}  onChange={(event) => mudaData(event.target.value)} ></input>
                
              </div>
              <div className='mapa'>
                <div id="map" className='normalscreen'></div>
              </div>
            </Row>
            <div className='seleciona_municipio'>
            <Translator path="dashboard.cidade"/> : <select name="municipios" id="municipio" value={municipioSelecionado} onChange={event => filtrarMunicipio(event.target.value, true, getLinguagem())}>
                    {getCidades().map((e, key) => {
                                          return (
                                            <option key={key} value={e["cod_municipio"]}>{e["municipio"]}</option>       
                                          );
                          })}
                </select> 
              </div>
            <Row>
              <Col>
                <Row>
                  <Col> 
                    <div className='grafico'>
                      <Button className='button_maximize float-right' onClick={() => setModal2Show(true)}></Button> 
                      <Line options={getOptions_Line_Double(max_data_media_movel, props.theme, true, t("dashboard.graficos.titulo_mm"))} data={dataMediaMovel}/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col> 
                    <div className='grafico' >
                      <Button className='button_maximize float-right' onClick={() => setModal1Show(true)}></Button>
                       <Line options={getOptions_Line(max_dados3 > max_vmm ? max_dados3 : max_vmm, props.theme, true, t("dashboard.graficos.titulo_variacao_mm"))} data={data_observed_number}  />
                    </div>
                  </Col>
                  
                </Row>
              </Col>
              <Col>           
                <Row>
                  <Col>
                    <div className='grafico'> 
                      <Button className='button_maximize float-right' onClick={() => setModal3Show(true)}></Button> 
                      <Bar options={getOptions(max_data2, props.theme, t("dashboard.graficos.titulo_atendimento_gripais"))} data={data2} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col> 
                    <div className='grafico'>
                      <Button className='button_maximize float-right' onClick={() => setModal4Show(true)}></Button> 
                      <Bar options={getOptions(max_data, props.theme, t("dashboard.graficos.titulo_atendimento_totais"))} data={data} />
                    </div>
                  </Col>
                </Row>   
              </Col>
              <Col>
                <Row>
                  <Col> 
                    <div className='grafico'>
                      <Button className='button_maximize float-right' onClick={() => setModal5Show(true)}></Button>  
                      <Line options={getOptions_Line(max_data_excess_thr, props.theme, false, t("dashboard.graficos.titulo_excesso"))} data={data_excess_thr} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col> 
                    <div className='grafico'>
                      <Button className='button_maximize float-right' onClick={() => setModal6Show(true)}></Button>  
                      <Line options={getOptions_Line_Double(max_o_num > max_u_b_thr ? max_o_num : max_u_b_thr, props.theme, false, t("dashboard.graficos.titulo_limite"))} data={data_o_num} />         
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <div className='table_container'>
                <div className='space_top'>
                <Translator path="dashboard.data"/>: <Moment date={dataSelecionada} format='DD/MM/YYYY'></Moment>
                  <br></br>
                  <input type={"range"} max={datas.length-1} min={0} /*defaultValue={0}*/ onChange={(event) => mudaData(event.target.value)} value={idxDataSelecionada} ></input>  
                </div>
                <div className='table'>
                  <Table id="dtBasicExample" striped bordered hover variant={props.theme === "dark" ? "dark" : ""}>
                    <thead>
                      <tr>
                        <th><a href='#' style={{color: campoOrdem === "municipio" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "municipio"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                          setCampoOrdem("municipio")}}> 
                          <img className={props.theme === "dark"? '' : 'invert'} src="/imagens/icones/setas-ordenadas.png" ></img> <Translator path={"dashboard.table.col1"}/></a></th>
                        <th><a href='#' style={{color: campoOrdem === "populacao" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "populacao"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                          setCampoOrdem("populacao")}}><img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col2"}/> </a></th>
                        <th><a href='#' style={{color: campoOrdem === "variacao_media_movel" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "variacao_media_movel"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("variacao_media_movel")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col3"}/>  </a></th>
                        <th><a href='#' style={{color: campoOrdem === "excesso" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "excesso"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("excesso")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col4"}/>  </a></th>
                        <th><a href='#' style={{color: campoOrdem === "limite_superior" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "limite_superior"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("limite_superior")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col5"}/>  </a></th>
                        <th><a href='#' style={{color: campoOrdem === "taxagripais_atendtotais" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "taxagripais_atendtotais"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("taxagripais_atendtotais")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col6"}/></a></th>
                        <th><a href='#' style={{color: campoOrdem === "total_gripal" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "total_gripal"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("total_gripal")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col7"}/>  </a></th>
                        <th><a href='#' style={{color: campoOrdem === "total_geral" ? "cadetblue" : ""}} onClick={() => {
                          if(campoOrdem === "total_geral"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                          setCampoOrdem("total_geral")}}> <img className={props.theme === "dark"? '' : 'invert'}  src='/imagens/icones/setas-ordenadas.png'></img> <Translator path={"dashboard.table.col8"}/>  </a></th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {tabelaOrdenada().map((value, index) => {
                                          return (
                                            <tr key={index}>
                                              <td className='linha_tabela'><a href='#' onClick={() => {filtrarMunicipio(value["cod_ibge"], true, getLinguagem())}}>{value["municipio"]}</a></td>
                                              <td className='linha_tabela numero_tabela'>{preparaInt(trataNaNeNull(value["populacao"]))}</td>
                                              <td className='linha_tabela numero_tabela'>{fixaCasasDecimais(trataNaNeNull(value["variacao_media_movel"]), 2)}</td>
                                              <td className='linha_tabela numero_tabela'>{preparaInt(trataNaNeNull(value["excesso"]))}</td>
                                              <td className='linha_tabela numero_tabela'>{preparaInt(trataNaNeNull(value["limite_superior"]))}</td>
                                              <td className='linha_tabela numero_tabela'>{fixaCasasDecimais(trataNaNeNull(value["taxagripais_atendtotais"]), 2)}</td>
                                              <td className='linha_tabela numero_tabela'>{preparaInt(trataNaNeNull(value["total_gripal"]))}</td>
                                              <td className='linha_tabela numero_tabela'>{preparaInt(trataNaNeNull(value["total_geral"]))}</td>
                                              
                                            </tr>
                                          );
                          })}  
                          
                    </tbody>
                  </Table>
                </div>
              </div>
            </Row>  
            <PopupGrafico 
                        show={modal1Show} 
                        onHide={() => setModal1Show(false)}
                        options= {getOptions_Line(max_dados3 > max_vmm ? max_dados3 : max_vmm, props.theme, true, t("dashboard.graficos.titulo_variacao_mm"))}
                        data = {data_observed_number}
                        type = "Line" 
                        titulo= {""}
                        linguagem = {props.data}
                      />
            <PopupGrafico 
                        show={modal2Show} 
                        onHide={() => setModal2Show(false)}
                        options= {getOptions_Line_Double(max_data_media_movel, props.theme, true, t("dashboard.graficos.titulo_mm"))}
                        data = {dataMediaMovel}
                        type = "Line" 
                        titulo= {""}
                        linguagem = {props.data}
                      />

            <PopupGrafico 
                        show={modal3Show} 
                        onHide={() => setModal3Show(false)}
                        options= {getOptions(max_data2, props.theme, t("dashboard.graficos.titulo_atendimento_gripais"))}
                        data = {data2}
                        type = "Bar" 
                        titulo= {""}
                        linguagem = {props.data}
                      />
          <PopupGrafico 
                        show={modal4Show} 
                        onHide={() => setModal4Show(false)}
                        options= {getOptions(max_data, props.theme, t("dashboard.graficos.titulo_atendimento_totais"))}
                        data = {data}
                        type = "Bar" 
                        titulo= {""}
                        linguagem = {props.data}
                      />
          <PopupGrafico 
                        show={modal5Show} 
                        onHide={() => setModal5Show(false)}
                        options= {getOptions_Line(max_data_excess_thr, props.theme, false, t("dashboard.graficos.titulo_excesso"))}
                        data = {data_excess_thr}
                        type = "Line" 
                        titulo= {""}
                        linguagem = {props.data}
                      />

          <PopupGrafico 
                        show={modal6Show} 
                        onHide={() => setModal6Show(false)}
                        options= {getOptions_Line_Double(max_o_num > max_u_b_thr ? max_o_num : max_u_b_thr, props.theme, false, t("dashboard.graficos.titulo_limite"))}
                        data = {data_o_num}
                        type = "Line" 
                        titulo= {""}
                        linguagem = {props.data}
                      />
          <Footer></Footer>
          </Container>  
        );
    } else {
      return(
        <div>Para visualizar os dados é necessário Login !</div>
      );
    }
});

export default Mapa